import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'asset-manage';

export const state = {
   
    isshowList: true,
    typeFlag :"", // 新增资产 1 原值增加 2  折旧  3  资产清理  4 
   
  
    detailParams:{},
    routerUrl:'',
    buttonType:"",
    isView:false,//查看模式
    storageClass:"",
    audit:false
   
}
export const mutations = {
    setIsshowList(state, flag) {
        state.isshowList = flag
    }, 
    settypeFlag(state,data){
        
        state.typeFlag  = data

    },
    setstorageClass(state,data){
        state.storageClass = data
    },
    setAssetView(state, flag) {
        state.isView = flag
    },
    setAssetAudit(state,flag){
        state.audit = flag
    },
    setAssetDetailParams(state,data){
        state.detailParams= {...data}
    },
    setAssetRouterUrl(state, url) {
        state.routerUrl = url
    },
    setAssetButtonType(state, type) {
        state.buttonType = type
    }
  
}
export const actions = {

}
export const getters = {
    title(state) {
        return state.typeFlag == 1?'新增资产':state.typeFlag == 2?'原值增加':state.typeFlag == 3?'折旧摊销':state.typeFlag == 4?"资产清理":''
    },
   

}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/asset-mange/index.js